<template>
    <div class="workSideNav">
        <ParkInfos></ParkInfos>
        <div class="work">
            <el-scrollbar style="height:100%" wrap-style="overflow-x:hidden;">
                <div class="title">
                    工作台
                </div>
                <div class="list">
                    <div class="land">
                        <div class="tt">最近使用</div>
                        <div class="cont" v-if="RecentlyUsed.length > 0">
                            <div class="item" v-for="(child, index) in RecentlyUsed" @click="tagmenu(child)"><img
                                    :src="child.img" alt="">{{ child.name }}</div>
                        </div>
                        <div class="cont" v-else>
                            <div class="item">暂无最近使用</div>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <div class="land" v-for="item in meneu">
                        <div class="tt">{{ item.name }}</div>
                        <div class="cont">
                            <div class="item" v-for="(child, index) in item.list" @click="tagmenu(child)"
                                :class="{ nocheck: !child.ischeck, active: active == child.url }"><img :src="child.img"
                                    alt="">{{ child.name }}</div>
                        </div>
                        <!-- <div class="cont" v-if="item.list.length>3">
                            <div class="item" v-for="(child,index) in item.list" v-if="index>2"  @click="tagmenu(child)" :class="{nocheck:!child.ischeck,active:active==child.url}"><img :src="child.img" alt="">{{child.name}}</div>
                        </div> -->
                    </div>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import ParkInfos from '../../../components/common/ParkInfos.vue';
export default {
    data() {
        return {
            uselist: [],
            active: ""
        }
    },
    components: {
        ParkInfos
    },
    computed: {
        projectId() {
            return this.$store.getters.projectId
        },
        RecentlyUsed() {
            return this.$store.state.project.RecentlyUsed
        },
        projectInfo() {
            return this.$store.getters.selProjectInfo
        },
        meneu() {
            let meneu = [
                {
                    name: "电力监控",
                    list: [
                        {
                            img: require("@/assets/img/pdt.png"),
                            name: "一次系统图",
                            url: "/Home/WorkBench/WiringLine",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/dltp.png"),
                            name: "电力拓扑图",
                            url: "/Home/WorkBench/PowerWiringLine",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/hljc.png"),
                            name: "回路监测",
                            url: "/Home/WorkBench/LoopMonitoring",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/byqjc.png"),
                            name: "变压器监测",
                            url: "/Home/WorkBench/PowerMonitoring",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/hlkz.png"),
                            name: "回路控制",
                            url: "/Home/WorkBench/loopControl",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/hlkz.png"),
                            name: "开关控制",
                            url: "/Home/WorkBench/SwitchControl",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/dnzl.png"),
                            name: "电能质量",
                            url: "/Home/WorkBench/CapacitanceCompensation",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/ups.png"),
                            name: "UPS监测",
                            url: "/Home/WorkBench/UPS",
                            checkNum: 0,
                            ischeck: false
                        },
                        
                        {
                            img: require("@/assets/img/jxtgj.png"),
                            name: "接线图工具",
                            url: "",
                            checkNum: 0,
                            ischeck: false
                        },
                        // {
                        //     img: require("@/assets/img/ups.png"),
                        //     name: "魅控监测",
                        //     url: "/Home/WorkBench/MakerMonitor",
                        //     checkNum: 0,
                        //     ischeck: false
                        // },
                        
                    ]
                },
                {
                    name: "微电网监测",
                    list: [
                        {
                            img: require("@/assets/img/gfzc.png"),
                            name: "光伏组串图",
                            url: "/Home/WorkBench/pvWiringLine",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/nbqjc.png"),
                            name: "逆变器监测",
                            url: "/Home/WorkBench/InverterMonitoring",
                            checkNum: 0,
                            ischeck: false
                        },
                        // {
                        //     img: require("@/assets/img/nbqjc.png"),
                        //     name: "充电桩监测",
                        //     url: "/Home/WorkBench/ChargingPileMonitoring",
                        //     checkNum: 0,
                        //     ischeck: true
                        // }
                    ]
                },
                {
                    name: "能耗管理",
                    list: [
                        {
                            img: require("@/assets/img/nhfx.png"),
                            name: "能耗分析",
                            url: "/Home/WorkBench/Comparison",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/nxpj.png"),
                            name: "能效评价",
                            url: "/Home/WorkBench/Savingplan",
                            checkNum: 0,
                            ischeck: false
                        },
                        {
                            img: require("@/assets/img/nhjb.png"),
                            name: "能耗简报",
                            url: "/Home/WorkBench/EnergyReport",
                            checkNum: 0,
                            ischeck: false
                        }
                    ]
                },
                {
                    name: "事件管理",
                    list: [
                        {
                            img: require("@/assets/img/lssj.png"),
                            name: "历史事件",
                            url: "/Home/WorkBench/EventManagement",
                            checkNum: 0,
                            ischeck: true
                        },
                        {
                            img: require("@/assets/img/ups.png"),
                            name: "报警设置",
                            url: "/Home/WorkBench/Police",
                            checkNum: 0,
                            ischeck: false
                        },
                    ]
                },
                {
                    name: "报表管理",
                    list: [
                        {
                            img: require("@/assets/img/dlbb.png"),
                            name: "电力报表",
                            url: "/Home/WorkBench/ReportForm?uid=PowerTime",
                            checkNum: 0,
                            ischeck: false

                        }, {
                            img: require("@/assets/img/gfbb.png"),
                            name: "光伏报表",
                            url: "/Home/WorkBench/pvReportForm?uid=Energy",
                            checkNum: 0,
                            ischeck: false

                        },
                        {
                            img: require("@/assets/img/nhbb.png"),
                            name: "能耗报表",
                            url: "/Home/WorkBench/EnergyReportForm?uid=Complex",
                            checkNum: 0,
                            ischeck: false
                        }
                    ]
                }, {
                    name: "物业管理",
                    list: [
                        {
                            img: require("@/assets/img/sbtz.png"),
                            name: "设备台账",
                            url: "/Home/WorkBench/EquipmentAccount",
                            checkNum: 0,
                            ischeck: true
                        },
                        {
                            img: require("@/assets/img/jfzd.png"),
                            name: "缴费账单",
                            url: "/Home/PaymentMeter/index"
                        }, {
                            img: require("@/assets/img/yccb.png"),
                            name: "远程抄表",
                            url: "/Home/WorkBench/MeterReading",
                            checkNum: 0,
                            ischeck: false
                        }, {
                            img: require("@/assets/img/txzt.png"),
                            name: "通讯状态",
                            url: "/Home/WorkBench/CommunicationStatus",
                            checkNum: 0,
                            ischeck: true
                        },
                        // {
                        //     img: require("@/assets/img/charge.png"),
                        //     name: "充电台账",
                        //     url: "/Home/WorkBench/ChargingLedger",
                        //     checkNum: 0,
                        //     ischeck: true
                        // }
                    ]
                }, {
                    name: "安防监控",
                    list: [
                        {
                            img: require("@/assets/img/spjk.png"),
                            name: "视频监控",
                            url: "/Home/WorkBench/chvideo",
                            checkNum: 0,
                            ischeck: false,
                        },
                        // {
                        //     img:require("@/assets/img/zl.png"),
                        //     name:"能耗类报表",
                        //     url:"/Home/WorkBench/ReportForm?uid=Storage"
                        // }
                    ]
                },
            ]


            if (this.projectInfo.menuAuth) {
                let list = ['PowerDistribution', 'Photovoltaic', 'EnergyConsumption', 'PaymentMeter']
                this.projectInfo.menuAuth.split(',').forEach(elm => {
                    if (elm == 'PowerDistribution') {
                        meneu[0].list[0].ischeck = true
                        meneu[0].list[2].ischeck = true
                        meneu[0].list[3].ischeck = true
                        meneu[4].list[0].ischeck = true
                    }
                    if (elm == 'Photovoltaic') {
                        meneu[1].list[0].ischeck = true
                        meneu[1].list[1].ischeck = true
                        meneu[4].list[1].ischeck = true
                    }
                    if (elm == 'EnergyConsumption') {
                        meneu[2].list[0].ischeck = true
                        meneu[2].list[1].ischeck = true
                        meneu[2].list[2].ischeck = true
                        meneu[4].list[2].ischeck = true
                    }
                    if (elm == 'PaymentMeter') {
                        meneu[5].list[1].ischeck = true
                        // meneu[5].list[2].ischeck = true
                    }
                })
            }

            if(this.$store.state.homeitem.user.roleId=='-9999'){
                meneu[3].list[1].ischeck = true
            }else{
                // meneu[3].list = meneu[3].list.slice(1,2)
            }
            
            if (this.projectId == 1) { //远程抄表
                meneu[5].list[2].ischeck = true
                meneu[0].list[6].ischeck = true
                meneu[0].list[8].ischeck = true
                // meneu[0].list[7].ischeck = true
            }
            if (this.projectId == 1||this.projectId == 13||this.projectId == 18) {  //开关控制 鳄鱼美 交投  昌华
                 meneu[0].list[5].ischeck = true
                // meneu[0].list[7].ischeck = true
            }
            if (this.projectId == 1||this.projectId == 18) {
                meneu[0].list[1].ischeck = true
                meneu[6].list[0].ischeck = true
            }
            if (this.projectId == 19) {  //协和
                meneu[0].list[6].ischeck = true
                meneu[6].list[0].ischeck = true
            }
            if (this.projectId == 1 || this.projectId == 13) {
                meneu[0].list[4].ischeck = true
                // meneu[5].list[2].ischeck = true
            }
            if (this.projectId == 1 || this.projectId == 4 || this.projectId == 5 || this.projectId == 16 || this.projectId == 6) { //电能质量
                meneu[0].list[6].ischeck = true
            }
            if(this.projectId == 4){
                meneu[0].list[4].ischeck = true
                meneu[5].list[2].ischeck = true
            }
            if (this.projectId == 18||this.projectId == 17) {  //交投
                meneu[0].list[4].ischeck = true
                meneu[2].list[0].ischeck = true
                meneu[0].list[6].ischeck = true
                meneu[0].list[7].ischeck = true
            }

            if (this.projectId == 13) {  //鳄鱼美
                meneu[5].list[2].ischeck = true
                // meneu[0].list[6].ischeck = true
                meneu[0].list[1].ischeck = true
                meneu[1].list[0].ischeck = true
                meneu[1].list[1].ischeck = true
                meneu[4].list[1].ischeck = true
                meneu[6].list[0].ischeck = true
            }
            if (this.projectId == 15) {  //鳄鱼美
                meneu[5].list[2].ischeck = true
            }

            // if (this.projectId == 14) {
            //     meneu[0].list[9].ischeck = true
            // }

            //进入工作太默认选中一个
            let map = []
            meneu.forEach(item=>{
                let state = item.list.filter(e=>{
                    if(e.ischeck&&e.name!="接线图工具"){
                        return e
                    }
                })
                if(state.length>0){
                    map = map.concat(state)
                }
            })



            this.$store.commit("setFirstPage",map[0])
            return meneu
        },
        routeName() {
            return this.$route.params.name;
        },
        tag() {
            return this.$route.params.tag;
        },
        parkInfo() {
            return this.$store.state.project.projectInfo
        },
        WeatherInfo() {
            return this.$store.state.project.WeatherInfo
        }

    },
    mounted() {
        this.uselist = this.RecentlyUsed
        if(this.$store.state.project.CurrWorkBenchPage){
            this.active = this.$store.state.project.CurrWorkBenchPage
        }
    },
    watch: {
        $route(n,o){
            
        },
        "$store.state.project.CurrWorkBenchPage"(n, o) {
            this.active = n
        },
        "$store.state.project.FirstPage"(n, o) {
            
        },
    },
    methods: {
        tagmenu(item) {
            if (!item.ischeck) {
                return false
            }
            this.$store.commit("setCurrWorkBench",item.url)

            if (item.name == '视频监控') {
                if(this.projectId==1){
                    let name = this.$store.state.homeitem.user.realName;
                    let userimg = this.$store.state.homeitem.user.img;
                    window.open("http://chvideo.energydt.cn:7001/chvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
                }else if(this.projectId==18){
                    let name = this.$store.state.homeitem.user.realName;
                    let userimg = this.$store.state.homeitem.user.img;
                    window.open("http://jtvideo.energydt.cn:7001/jtvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
                }else if(this.projectId==19){
                    let name = this.$store.state.homeitem.user.realName;
                    let userimg = this.$store.state.homeitem.user.img;
                    window.open("http://xiehevideo.energydt.cn:7001/xhvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
                }else if(this.projectId==13){
                    window.open("http://218.200.95.220:38080/ebs-video/#/","_blank");
                }
                return false
            }
            if (item.name == '接线图工具') {
                window.open("http://local.vrmaker.vip:38080/web-editor/#/","_blank");
                return false
            }

            this.active = item.url
            //最近使用处理
            // item.checkNum++
            // let obj = this.uselist.find(a => { return a.name == item.name; })
            // if (obj) {
            //     this.uselist = this.uselist.map(a => { if (a.name == item.name) { a = item } return a })
            // } else {
            //     this.uselist.unshift(item)
            // }
            // let list = this.uselist
            // let d = list.sort((a, b) => { return b.checkNum - a.checkNum }) //降序
            // this.uselist.unshift(item)
            // this.uselist = this.uselist.filter((e, l) => l <= 2)

            let obj = this.uselist.find(a => { 
                    return a.name == item.name;
             })
            if (obj) {
                this.uselist = this.uselist.filter(a =>{
                    return a.name != item.name
                })
                this.uselist.unshift(item)
            } else {
                this.uselist.unshift(item)
            }
            this.uselist = this.uselist.filter((e, l) => l <= 2)
            this.$store.commit('setRecentlyUsed', this.uselist)
        
            this.$router.push(item.url)
        }
    }
}
</script>

<style lang="less" scoped>
.workSideNav {
    height: 100%;
    background: #ffffff;
    width: 100%;

    .title {
        font-size: 16rem;
        border-left: 5rem solid #0D94FF;
        height: 18px;
        line-height: 18px;
        padding-left: 6px;
        margin: 10rem 0 10rem 10rem;
    }

    .work {
        .h(850);
    }

    .list {
        border-top: 1px solid rgba(0, 0, 0, 0.06);
    }

    .land {
        padding: 20rem 0 10rem 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        // cursor: pointer;

        .tt {
            font-size: 16rem;
            font-weight: 400;
            color: #666666;
            padding-left: 30rem;
        }

        .cont {
            // border-bottom:1px solid rgba(0, 0, 0, 0.06);
            // padding-left: 30rem;
            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            overflow: hidden;

            //   .h(80);
            .item {
                //width: 34%;
                display: inline-block;
                .w(172);
                font-size: 16rem;
                border-radius: 8rem;
                padding: 8px 10px;
                margin: 10rem 0 10rem 18rem;
                cursor: pointer;
                img {
                    // width: 42rem;
                    // height: 42rem;
                    vertical-align: middle;
                    margin-right: 10rem;
                }
            }

            .active {
                background: rgba(0, 0, 0, 0.04);
            }

            .nocheck {
                // background: #F6F6F6;
                cursor: no-drop;
                // color: #F6F6F6;
                opacity: 0.5;
                filter: grayscale(1);
            }
        }

    }
}
</style>